import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'core/api/api.service';
import { AppInfoService } from 'core/app-info/app-info.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { NotificationService } from 'core/notification/notification.service';
@Component({
  selector: 'app-leads-delete',
  templateUrl: './leads-delete.component.html',
  styleUrls: ['./leads-delete.component.scss'],
  standalone: false
})

export class LeadsDeleteComponent implements OnInit {
  selectForm;
  private url = {
    deleteLead: '/api/lead/delete',
    deleteDelivery: '/api/delivery/delete'
  };
  appStrings = this.appInfoService.appStrings;
  leadId: any;
  leadType: any;
  isLead;
  componentTitle;

  constructor(
    public dialogRef: MatDialogRef<LeadsDeleteComponent>,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public apiService: ApiService,
    private appInfoService: AppInfoService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.leadId = data.leadId;
    this.leadType = data.leadType;
  }

  ngOnInit() {
    this.selectForm = this.formBuilder.group({
      reason: ['', Validators.required]
    });

    this.isLead = this.leadType === 'Lead';
    this.componentTitle = this.isLead ? this.appStrings.leads_deleteLeadTitle : this.appStrings.leads_deleteDeliveryTitle;
  }

  close(deletionIsDone?): void {
    this.dialogRef.close(deletionIsDone);
  }

  deleteLead() {
    const confirmationMessage = this.isLead ? this.appStrings.leads_leadDeletedNotification :
      this.appStrings.leads_deliveryLocationDeletedNotification;

    this.selectForm.markAllAsTouched();

    if (this.selectForm.valid) {
      const url = this.isLead ? this.url.deleteLead : this.url.deleteDelivery;
      this.apiService.post(
        url,
        {
          id: this.leadId,
          deleteReason: this.selectForm.controls.reason.value
        }
      ).subscribe(() => {
        this.close(true);
        this.notificationService.showNotification(confirmationMessage, NotificationType.Success);
        setTimeout(() => {
          this.router.navigate(['/accounts']);
        }, 1000);
      });
    }
  }
}
